var app = {
	header: {
		build: "Build",
		closeButton: "Bezárás",
		copyrightLabel: "Szerzői jog",
		helpLabel: "Segítség",
		legalNoticeLabel: "Jogi nyilatkozat",
		logoutButton: "Kijelentkezés",
		menuLabel: "Menü",
		module: "Modul",
		myData: "Saját adataim",
		noUserDataLabel: "Nincs felhasználói adat elérhető",
		notificationsLabel: "Értesítések",
		privacyPolicyLabel: "Adatvédelmi irányelvek",
		search: "Keresés",
		searchPlaceholder: "Keresési kifejezés vagy kérdés",
		serviceAppLabel: "Szolgáltatás-App",
		settingsLabel: "Beállítások",
		shopLabel: "Bolt",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		softwareInformation: "Szoftverinformációk",
		toMytrumpf: "A MyTRUMPF-hoz",
		toTrumpfCom: "A trumpf.com-hoz",
		userLabel: "Profil",
		userProfileLinkText: "Felhasználói Profil",
		version: "Verzió"
	}
};
var contentLoadingError = "A tartalom nem tölthető be";
var dashboard = {
	cancel: {
		button: "Mégse"
	},
	edit: {
		button: "Szerkesztés"
	},
	reset: {
		button: "Visszaállítás"
	},
	save: {
		button: "Mentés"
	},
	share: {
		button: "Megosztás"
	}
};
var fileUpload = {
	invalidFileType: "A fájl rossz típusú",
	maxFileSize: "A fájl nagyobb, mint a megengedett (max. {{maxSizeInMb}} MB)",
	maxFilesReached: "Elérte a maximális fájlok számát"
};
var filter = {
	clear: "Szűrők visszaállítása",
	clearAll: "Összes szűrő visszaállítása"
};
var general = {
	nextButton: "Következő",
	prevButton: "Előző",
	resetButton: "Visszaállítás"
};
var locationMap = {
	locationLink: {
		label: "A helyszínhez"
	}
};
var machineDiscontinuation = {
	linkText: "Tudjon meg többet"
};
var notifications = {
	button: {
		loadMore: "Továbbiak betöltése"
	},
	date: {
		lastMonth: "Előző hónap",
		lastWeek: "Előző hét",
		older: "Régebbi",
		thisMonth: "Ez a hónap",
		thisWeek: "Ez a hét",
		today: "Ma",
		yesterday: "Tegnap"
	},
	error: {
		general: "Jelenleg nem jeleníthető meg értesítések. Kérjük, próbálja újra később.",
		unauthorized: "Kérjük, jelentkezzen be az értesítések megtekintéséhez"
	},
	info: {
		activateSettings: "Az értesítések fogadásához, kérjük, engedélyezze őket a beállításokban",
		noNotification: "Jelenleg nincsenek üzenetei."
	},
	title: "Értesítések"
};
var results = {
	counter: {
		label: "találat"
	}
};
var scrollToTop = {
	label: "Görgetés a lap tetejére"
};
var slider = {
	nextButton: {
		label: "Következő dia"
	},
	paginationBullet: {
		label: "Dia"
	},
	prevButton: {
		label: "Előző dia"
	}
};
var sorting = {
	ascending: "Növekvő",
	descending: "Csökkenő"
};
var userAccount = {
	address: {
		label: "Postacím"
	},
	email: {
		label: "Email"
	},
	language: {
		label: "Nyelv",
		locale: "Hely",
		select: "Nyelv kiválasztása",
		settings: "Nyelvi beállítások"
	},
	loggedOut: {
		message: "Nem jelentkezett be"
	},
	login: {
		button: "Bejelentkezés"
	},
	name: {
		label: "Név"
	},
	phone: {
		label: "Telefon"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Gépek szűrése",
			label: "Gépek",
			option: {
				all: "Összes gép"
			},
			select: "Gép kiválasztása"
		},
		period: {
			label: "Időszak",
			option: {
				currentMonth: "Ez a hónap",
				currentWeek: "Ez a hét",
				lastMonth: "Előző hónap",
				lastWeek: "Előző hét",
				today: "Ma",
				yesterday: "Tegnap"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Widgetjeim"
	},
	noDescriptionAvailable: "Leírás nem érhető el.",
	widget: {
		SampleMyMachines: {
			title: "Gépeim"
		},
		SampleMyServiceCalls: {
			title: "Szervizhívások"
		},
		SampleMyTrackingList: {
			title: "Nyomkövetési lista"
		},
		SampleMyUserAccount: {
			title: "Profilom"
		},
		SampleOperationalStatesChart: {
			title: "Üzemállapotok"
		},
		SampleWidgetFilter: {
			title: "Szűrőbeállítások"
		},
		SampleWorkloadBalanceChart: {
			title: "Munkaterhelés egyensúlya"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	fileUpload: fileUpload,
	filter: filter,
	general: general,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, fileUpload, filter, general, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
